import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import DocumentTitle from 'react-document-title';
import _ from 'lodash';

import Screen from '../../../components/Screen';
import { EmptyPage, PageLoader } from '../../../components/PageWrapper';
import { MatchType } from '../../../types/router';
import { defControllerView } from '../../../utils';
import ReservationDetailsList from '../components/ReservationDetailsList';
import { localize } from '../../../i18n';

class ReservationDetails extends PureComponent {
  componentDidMount() {
    const {
      reservationCtrl,
    } = this.props;

    reservationCtrl.getAllReservations();
  }

  render() {
    const {
      reservationCtrl,
      match: {
        params: {
          reservationId,
        },
      },
      data: {
        ready,
      },
      location,
      t,
    } = this.props;

    const backUrl = _.get(location.state, 'returnPathname', '/access/chat');

    const emptyScreen = (
      <EmptyPage icon="error" offset={88}>
        {t('Reservation is not found')}
      </EmptyPage>
    );

    let page = (<PageLoader offset={44} title={t('Getting reservations')} />);

    // Reservations ready
    if (ready) {
      const reservation = reservationCtrl.getReservationById(reservationId);
      page = reservation ? (<ReservationDetailsList reservation={reservation} />) : emptyScreen;
    }

    return (
      <Screen title="Guest Info" helpUrl="#guests" backUrl={backUrl}>
        <DocumentTitle title={t('Reservation Details')} />
        {page}
      </Screen>
    );
  }
}

ReservationDetails.propTypes = {
  match: MatchType,
  reservationCtrl: PropTypes.shape({}),
  data: PropTypes.shape({}),
  t: PropTypes.func,
  location: PropTypes.shape({}),
};

export default defControllerView('ReservationController', 'reservationCtrl')(localize(ReservationDetails));



// WEBPACK FOOTER //
// ./src/views/chat/views/ReservationDetails.js